import React from 'react';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ChevronWrapper } from 'src/ui/components/collapse/sports/05/Collapse.style';
import {
    RowLinkDetails,
    RowLinkLabel,
    RowLinkLabelWrapper,
    TableSportsRowLinkFlag,
    TableSportsRowLinkWrapper,
} from 'src/ui/components/table/sports/row/link/TableSportsRowLink.style';
import { observer } from 'src/utils/mobx-react';

interface TableSportsRowLinkPropsType {
    className?: string;
    dataTest?: string;
    flagCode?: string;
    formattedDate: string;
    handleClick: () => void;
    label: string;
}

export const TableSportsRowLink = observer(
    'TableSportsRowLink',
    ({
        className,
        dataTest,
        flagCode,
        formattedDate,
        handleClick,
        label,
    }: TableSportsRowLinkPropsType): JSX.Element => {
        const sportsbookVariant = DefaultComponentVariantType.TERTIARY;
        return (
            <TableSportsRowLinkWrapper
                className={className}
                onClick={handleClick}
                data-test={dataTest ?? 'table-sports-row-link-wrapper'}
                variant={sportsbookVariant}
            >
                <RowLinkLabelWrapper>
                    {flagCode !== undefined && (
                        <TableSportsRowLinkFlag
                            flagCode={flagCode}
                            dataTest='table-sports-row-link-flag'
                        />
                    )}

                    <RowLinkLabel data-test='table-sports-row-link-label'>{label}</RowLinkLabel>
                    {formattedDate !== '' && (
                        <RowLinkDetails variant={sportsbookVariant}>{formattedDate}</RowLinkDetails>
                    )}
                </RowLinkLabelWrapper>
                <ChevronWrapper
                    size={20}
                    position={'right'}
                />
            </TableSportsRowLinkWrapper>
        );
    }
);
